if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector('.js-results-container');
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector('.js-message-error');
      this.errorMessageText = this.errorMessageContainer
        ? this.errorMessageContainer.querySelector('[data-text]')
        : null;
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);
        this.updateSearchQueryStateClass();

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();

            return;
          }

          this.isOpen = true;

          this.getSearchResults(searchTerm);
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
      });

      if (this.resultsContainer) {
        this.addEventListener('click', e => {
          const link = e.target.closest('a.js-popular-search-term');

          if (!link || !this.contains(link)) {
            return;
          }

          e.preventDefault();
          clearTimeout(this.timeout);

          const term = (link.getAttribute('data-search-term') || '').trim();

          if (!term) {
            return;
          }

          this.input.value = term;
          this.updateSearchQueryStateClass();
          this.isOpen = true;
          this.getSearchResults(term);
        });
      }
    }

    updateSearchQueryStateClass() {
      if (!this.input) {
        return;
      }

      const hasQuery = this.input.value.trim().length > 0;

      this.classList.toggle('search--has-query', hasQuery);
    }

    async getSearchResults(searchTerm) {
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,collection,query&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;

        if (typeof jscInitGridVariantPillScrollInContext === 'function') {
          jscInitGridVariantPillScrollInContext(this.resultsContainer);
        } else if (typeof jscInitGridVariantPillScroll === 'function') {
          jscInitGridVariantPillScroll(this.resultsContainer);
        }

        this.open();
      } catch (error) {
        if (this.errorMessageText) {
          this.errorMessageText.textContent = error.message;
        }
        if (this.errorMessageContainer) {
          this.errorMessageContainer.classList.remove('hidden');
        }
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      if (this.errorMessageContainer) {
        this.errorMessageContainer.classList.add('hidden');
      }
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      if (this.errorMessageContainer) {
        this.errorMessageContainer.classList.add('hidden');
      }
      this.input.value = '';
      this.updateSearchQueryStateClass();
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
